import { PARCELLING_TYPE_OPTIONS } from '../../constants/parcellingType.constant';
import { ParcellingType } from '../../types';
import styles from './ParcellingTypeSelector.module.css';

export interface ParcellingTypeSelectorProps {
    value: ParcellingType | '';
    onChange: (value: ParcellingType) => void;
    disabled?: boolean;
    canSelectDynamic?: boolean;
    hasError?: boolean;
}

export const ParcellingTypeSelector = ({
    value,
    onChange,
    disabled,
    canSelectDynamic = true,
    hasError,
}: ParcellingTypeSelectorProps) => (
    <div className={styles.group} role="radiogroup" aria-label="Tipo de parcelamento">
        {PARCELLING_TYPE_OPTIONS.map((option) => {
            const isSelected = value === option.value;
            return (
                <button
                    key={option.value}
                    type="button"
                    role="radio"
                    aria-checked={isSelected}
                    className={`${styles.option} ${isSelected ? styles.selected : ''} ${hasError ? styles.error : ''}`}
                    onClick={() => onChange(option.value)}
                    disabled={disabled || (option.value === 'dynamic' && !canSelectDynamic)}
                    title={option.value === 'dynamic' && !canSelectDynamic ? 'Somente administradores podem criar parcelamentos dinâmicos' : undefined}
                >
                    <span className={styles.dot} />
                    <span className={styles.label}>{option.label}</span>
                </button>
            );
        })}
    </div>
);
